import { useNavigate } from "react-router-dom";
import BanqueService from "../../services/Banque";
import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";

const AllBanqueAccounts = ({ startLoading, stopLoading }) => {
  const [banqueAccountInfo, setBanqueAccountInfo] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    startLoading()
    BanqueService.getAllAccounts()
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "empty") {
          setBanqueAccountInfo([]);
        } else {
          setBanqueAccountInfo(response.data.success);
        }
      })
      .catch(() => {
        console.log("error");
      }).finally(() => {
        stopLoading();        
      });
  }, []);

  const navigateToAddBanqueHandler = () => {
    navigate("/addBanqueAccount");
  };


  const onViewTransctionsHandler = (idBankAccount, ele) => {
    sessionStorage.setItem("idBankAccount", idBankAccount);
    sessionStorage.setItem("bankAccountData", JSON.stringify(ele));
    navigate("/getTransactionsByBankAccount");
  };


    const onViewExtraitHandler = (idBankAccount) => {
    sessionStorage.setItem("idBankAccount", idBankAccount);
    navigate("/getExtraitByBankAccount");
  };
  const onViewAgendaHandler = (idBankAccount) => {
    sessionStorage.setItem("idBankAccount", idBankAccount);
    navigate("/agendaPayement");
  };
  const onViewPaymentsHandler = (idBankAccount) => {
    sessionStorage.setItem("idBankAccount", idBankAccount);
    navigate("/getPayementsByBankAccount");
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Comptes </h5>

                  <button
                    class="btn btn-dark  float-right"
                    onClick={navigateToAddBanqueHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
             
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Les comptes</h3>
                  <div class="card-tools">
                    <button
                      type="button"
                      class="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0">
                  <table class="table projects">
                    <thead>
                      <tr>
                        <th>Numéro de compte</th>
                        <th>Nom</th>
                        <th>Solde</th>
                        <th>Location</th>
                        <th>Agenda</th>
                        <th>Transactions</th>
                       <th>Extrait</th>

                        <th>Bordereau</th>

                      </tr>
                    </thead>
                    <tbody>
                      {banqueAccountInfo &&
                        banqueAccountInfo.map((ele) => (
                          <tr key={ele.id}>
                            <td> {ele.rib}</td>

                            <td> {ele.name}</td>
                            <td> {ele.solde}</td>
                            <td> {ele.agenceLocalisation}</td>
                            <td>  <button
                              style={{ width: 40 }}
                              class="btn bg-black btn-sm "
                              onClick={() => onViewAgendaHandler(ele.idBankAccount)}
                            >
                              <i class="fas fa-money-bill-transfer"></i>
                            </button></td>
                          

                             <td>  <button
                              style={{ width: 40 }}
                              class="btn bg-black btn-sm "
                              onClick={() => onViewTransctionsHandler(ele.idBankAccount, ele)}
                            >
                              <i class="fas fa-money-bill-transfer"></i>
                            </button></td>

                              <td>  <button
                              style={{ width: 40 }}
                              class="btn bg-black btn-sm "
                              onClick={() => onViewExtraitHandler(ele.idBankAccount)}
                            >
                              <i class="fas fa-money-bill-transfer"></i>
                            </button></td>

                            <td> {ele.idAgence !== null && <button
                              style={{ width: 40 }}
                              class="btn bg-black btn-sm "
                              onClick={() => onViewPaymentsHandler(ele.idBankAccount)}
                            >
                              <i class="fas fa-money-bill-transfer"></i>
                            </button>
                            } </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(AllBanqueAccounts);
